<template>
  <div class="container-fluid">
    <div class="page-title">
      <div class="row">
        <div class="col-6">
          <h3>KYT Detail</h3>
        </div>
        <div class="col-6">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link to="/">Home</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link to="/kyt-chain/logs">KYT Logs</router-link>
            </li>
            <li class="breadcrumb-item">
              <router-link :to="`/kyt-chain/logs/${logNo}/kyts`">{{ logNo }}</router-link>
            </li>
            <li class="breadcrumb-item active">KYT Detail</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid" v-if="loading">
    <div class="text-center p-5">
      <div class="spinner-border text-primary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
      <p class="mt-3">Loading KYT details...</p>
    </div>
  </div>

  <div class="container-fluid" v-else-if="kytDetail">
    <!-- Chain Navigation Breadcrumb -->
    <!-- <div class="row mb-3">
      <div class="col-12">
        <div class="card bg-light">
          <div class="card-body py-2">
            <div class="d-flex align-items-center justify-content-between">
              <div class="chain-breadcrumb">
                <vue-feather type="link" class="me-2 text-primary"></vue-feather>
                <span class="fw-bold text-primary">KYT Chain: {{ logNo }}</span>
                <span class="mx-2">→</span>
                <span class="badge bg-info">Generation {{ getKytGeneration() }}</span>
                <span class="mx-2">→</span>
              </div>
              <div class="chain-actions">
                <button
                  @click="viewChainOverview"
                  class="btn btn-outline-primary btn-sm me-2"
                >
                  <vue-feather type="layers" size="16" class="me-1"></vue-feather>
                  View Chain
                </button>
                <span class="badge" :class="getChainStatusBadge()">
                  {{ getChainStatus() }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div> -->

    <!-- Action Buttons -->
    <div class="row mb-3">
      <div class="col-12">
        <div class="btn-group float-end">
          <button @click="goBack" class="btn btn-secondary">
            <vue-feather type="arrow-left" class="me-1"></vue-feather>
            Back to Chain
          </button>
          <button @click="refreshData" class="btn btn-primary">
            <vue-feather type="refresh-cw" class="me-1"></vue-feather>
            Refresh
          </button>
          <button @click="exportData" class="btn btn-success">
            <vue-feather type="download" class="me-1"></vue-feather>
            Export
          </button>
        </div>
      </div>
    </div>

    <!-- Chain Overview Stats -->
  

    <!-- Comprehensive Statistics -->
    <div class="row" v-if="kytDetail.comprehensiveStats">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5>
              <vue-feather type="bar-chart-2" class="me-2"></vue-feather>
              Current KYT Statistics
            </h5>
            <small class="text-muted">Statistics for this specific KYT only</small>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-4 col-sm-6">
                <div class="stat-card bg-primary">
                  <div class="stat-icon">
                    <vue-feather type="layers"></vue-feather>
                  </div>
                  <div class="stat-content">
                    <h4>{{ kytDetail.comprehensiveStats.totalSubCategories }}</h4>
                    <span>Sub Categories</span>
                    <small class="d-block">In this KYT</small>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6">
                <div class="stat-card bg-success">
                  <div class="stat-icon">
                    <vue-feather type="check-circle"></vue-feather>
                  </div>
                  <div class="stat-content">
                    <h4>{{ kytDetail.comprehensiveStats.completedSubCategories }}</h4>
                    <span>Completed</span>
                    <small class="d-block">Sub Categories</small>
                  </div>
                </div>
              </div>
              <div class="col-md-4 col-sm-6">
                <div class="stat-card bg-info">
                  <div class="stat-icon">
                    <vue-feather type="briefcase"></vue-feather>
                  </div>
                  <div class="stat-content">
                    <h4>{{ kytDetail.comprehensiveStats.totalAssignments }}</h4>
                    <span>Assignments</span>
                    <small class="d-block">Active in this KYT</small>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mt-3">
              <div class="col-md-6">
                <h6>Current KYT Completion</h6>
                <div class="progress mb-2" style="height: 30px">
                  <div
                    class="progress-bar"
                    :class="
                      getProgressBarClass(kytDetail.comprehensiveStats.overallCompletion)
                    "
                    :style="{
                      width: kytDetail.comprehensiveStats.overallCompletion + '%',
                    }"
                  >
                    {{ kytDetail.comprehensiveStats.overallCompletion }}%
                  </div>
                </div>
                <small class="text-muted">Progress of current KYT only</small>
              </div>
              <div class="col-md-6">
                <h6>Verification Rate</h6>
                <div class="progress mb-2" style="height: 30px">
                  <div
                    class="progress-bar bg-info"
                    :style="{
                      width: kytDetail.comprehensiveStats.verificationRate + '%',
                    }"
                  >
                    {{ kytDetail.comprehensiveStats.verificationRate }}%
                  </div>
                </div>
                <small class="text-muted">Work verified in this KYT</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Basic Information -->
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5>Basic Information</h5>
          </div>
          <div class="card-body">
            <table class="table table-borderless">
              <tr>
                <td><strong>Log Number:</strong></td>
                <td class="text-primary">{{ logNo }}</td>
              </tr>
              <tr>
                <td><strong>Site Name:</strong></td>
                <td>{{ kytDetail.siteName }}</td>
              </tr>
              <tr>
                <td><strong>Status:</strong></td>
                <td>
                  <span class="badge" :class="getKytStatusBadgeClass(kytDetail.status)">
                    {{ kytDetail.status.toUpperCase() }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><strong>Completed:</strong></td>
                <td>
                  <span
                    class="badge"
                    :class="kytDetail.isCompleted ? 'badge-success' : 'badge-warning'"
                  >
                    {{ kytDetail.isCompleted ? "Yes" : "No" }}
                  </span>
                </td>
              </tr>
              <tr>
                <td><strong>NFD:</strong></td>
                <td>{{ kytDetail.formattedDates?.NFD || kytDetail.NFD }}</td>
              </tr>
              <tr>
                <td><strong>Work Description:</strong></td>
                <td>{{ kytDetail.workDescription }}</td>
              </tr>
              <tr>
                <td><strong>Type of CDW:</strong></td>
                <td>{{ kytDetail.typeOfCDW }}</td>
              </tr>
              <tr>
                <td><strong>Priority:</strong></td>
                <td>
                  <span
                    class="badge"
                    :class="kytDetail.isPriority ? 'badge-danger' : 'badge-secondary'"
                  >
                    {{ kytDetail.isPriority ? "High" : "Normal" }}
                  </span>
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5>Site Information</h5>
          </div>
          <div class="card-body" v-if="kytDetail.siteId">
            <table class="table table-borderless">
              <tr>
                <td><strong>Site Name:</strong></td>
                <td>{{ kytDetail.siteId.siteName }}</td>
              </tr>
              <tr>
                <td><strong>Address:</strong></td>
                <td>{{ kytDetail.siteId.siteAddress }}</td>
              </tr>
              <tr>
                <td><strong>Site Address:</strong></td>
                <td>{{ kytDetail.siteAddress }}</td>
              </tr>
              <tr>
                <td><strong>Landmark:</strong></td>
                <td>{{ kytDetail.landmark || "N/A" }}</td>
              </tr>
              <tr>
                <td><strong>Coordinates:</strong></td>
                <td>{{ kytDetail.siteLat }}, {{ kytDetail.siteLong }}</td>
              </tr>
              <tr>
                <td><strong>Website:</strong></td>
                <td>{{ kytDetail.websiteUrl || "N/A" }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Employee Information -->
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5>Assigned Employee</h5>
          </div>
          <div class="card-body" v-if="kytDetail.empId">
            <table class="table table-borderless">
              <tr>
                <td><strong>Name:</strong></td>
                <td>{{ kytDetail.empId.employeeName }}</td>
              </tr>
              <tr>
                <td><strong>Code:</strong></td>
                <td>{{ kytDetail.empId.employeeCode }}</td>
              </tr>
              <tr>
                <td><strong>Email:</strong></td>
                <td>{{ kytDetail.empId.email || "N/A" }}</td>
              </tr>
              <tr>
                <td><strong>Type of CDW:</strong></td>
                <td>{{ kytDetail.typeOfCDW }}</td>
              </tr>
              <tr>
                <td><strong>Work Duration:</strong></td>
                <td>{{ kytDetail.workDuration }} hours</td>
              </tr>
              <tr>
                <td><strong>Travel Duration:</strong></td>
                <td>{{ kytDetail.travelDuration }} hours</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <h5>Contact Information</h5>
          </div>
          <div class="card-body">
            <table class="table table-borderless">
              <tr>
                <td><strong>Contact Person:</strong></td>
                <td>{{ parseContactPerson(kytDetail.contact_person)?.name || "N/A" }}</td>
              </tr>
              <tr>
                <td><strong>Designation:</strong></td>
                <td>
                  {{ parseContactPerson(kytDetail.contact_person)?.designation || "N/A" }}
                </td>
              </tr>
              <tr>
                <td><strong>Phone:</strong></td>
                <td>
                  {{ parseContactPerson(kytDetail.contact_person)?.phone || "N/A" }}
                </td>
              </tr>
              <tr>
                <td><strong>Alt Phone:</strong></td>
                <td>
                  {{ parseContactPerson(kytDetail.contact_person)?.altPhone || "N/A" }}
                </td>
              </tr>
              <tr>
                <td><strong>Email:</strong></td>
                <td>
                  {{ parseContactPerson(kytDetail.contact_person)?.email || "N/A" }}
                </td>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>

    <!-- Assigned Managers -->
    <div
      class="row"
      v-if="kytDetail.assignedManagers && kytDetail.assignedManagers.length > 0"
    >
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5>Assigned Managers</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Manager Name</th>
                    <th>Employee Code</th>
                    <th>Assigned Date</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="manager in kytDetail.assignedManagers"
                    :key="manager.empId._id"
                  >
                    <td>{{ manager.empId.employeeName }}</td>
                    <td>{{ manager.empId.employeeCode }}</td>
                    <td>{{ manager.date }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Follow-ups -->
    <div class="row" v-if="kytDetail.followUps && kytDetail.followUps.length > 0">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5>Follow-ups</h5>
          </div>
          <div class="card-body">
            <div class="table-responsive">
              <table class="table">
                <thead>
                  <tr>
                    <th>Type</th>
                    <th>NFD</th>
                    <th>Rating</th>
                    <th>Meeting Report</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(followUp, index) in kytDetail.followUps" :key="index">
                    <td>
                      <span v-if="followUp.isCall" class="badge badge-info me-1"
                        >Call</span
                      >
                      <span v-if="followUp.isVisit" class="badge badge-success"
                        >Visit</span
                      >
                    </td>
                    <td>{{ followUp.NFD }}</td>
                    <td>{{ followUp.rating }}</td>
                    <td>
                      <ul class="list-unstyled mb-0">
                        <li v-for="(report, idx) in followUp.meetingReport" :key="idx">
                          {{ report }}
                        </li>
                      </ul>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Sub Categories Details -->
    <div class="row" v-if="kytDetail.subCategories && kytDetail.subCategories.length > 0">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5>Sub Categories</h5>
          </div>
          <div class="card-body">
            <div
              v-for="subCategory in kytDetail.subCategories"
              :key="subCategory._id"
              class="mb-4"
            >
              <div class="card border">
                <div class="card-header bg-light">
                  <div class="row align-items-center">
                    <div class="col-md-3">
                      <h6 class="mb-0 text-dark">{{ subCategory.subCategoryName }}</h6>
                      <small class="text-muted">{{ subCategory.subCategoryLogNo }}</small>
                      <div class="mt-1">
                        <span
                          v-if="isCascadedSubCategory(subCategory)"
                          class="badge badge-warning badge-sm"
                        >
                          <vue-feather
                            type="arrow-right"
                            size="12"
                            class="me-1"
                          ></vue-feather>
                          Cascaded
                        </span>
                        <span
                          v-if="subCategory.cascadeInfo?.cascadeGeneration"
                          class="badge badge-info badge-sm ms-1"
                        >
                          Gen {{ subCategory.cascadeInfo.cascadeGeneration }}
                        </span>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <span
                        class="badge"
                        :class="getSubCategoryStatusBadgeClass(subCategory.status)"
                      >
                        {{ subCategory.status }}
                      </span>
                      <div class="mt-1">
                        <small class="text-muted">{{
                          formatDate(subCategory.subCategoryDate)
                        }}</small>
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="progress">
                        <div
                          class="progress-bar"
                          :class="getProgressBarClass(subCategory.completionPercentage)"
                          :style="{ width: subCategory.completionPercentage + '%' }"
                        >
                          {{ subCategory.completionPercentage }}%
                        </div>
                      </div>
                      <small class="text-muted">Completion Rate</small>
                    </div>
                    <div class="col-md-2">
                      <div class="text-center">
                        <strong
                          >{{ subCategory.stats?.completedAssignments || 0 }}/{{
                            subCategory.stats?.totalAssignments || 0
                          }}</strong
                        >
                        <small class="d-block text-muted">Assignments</small>
                      </div>
                    </div>
                    <div class="col-md-2">
                      <div class="text-center">
                        <span
                          v-if="subCategory.cascadeInfo?.totalOriginalEmployees"
                          class="badge badge-secondary"
                        >
                          {{ subCategory.cascadeInfo.completedEmployees }}/{{
                            subCategory.cascadeInfo.totalOriginalEmployees
                          }}
                          Original
                        </span>
                        <small
                          v-if="subCategory.cascadeInfo?.isPartialCascade"
                          class="d-block text-warning"
                        >
                          Partial Cascade
                        </small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card-body">
                  <div class="row mb-3">
                    <div class="col-md-6">
                      <h6>Problem</h6>
                      <p>{{ subCategory.problem || "No problem described" }}</p>
                    </div>
                    <div class="col-md-6">
                      <h6>Solution</h6>
                      <p>{{ subCategory.solution || "No solution provided" }}</p>
                    </div>
                  </div>

                  <!-- Assignments -->
                  <h6>Assignments</h6>
                  <div
                    v-if="subCategory.assignments && subCategory.assignments.length > 0"
                    class="table-responsive"
                  >
                    <table class="table table-sm">
                      <thead>
                        <tr>
                          <th>Assignment ID</th>
                          <th>Employee</th>
                          <th>Status</th>
                          <th>Work Description</th>
                          <th>Quality Score</th>
                          <th>Photos</th>
                          <th>Dates</th>
                          <th>Chain Info</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="assignment in subCategory.assignments"
                          :key="assignment._id"
                        >
                          <td>
                            {{ assignment.assignmentId }}
                            <div v-if="isOriginalAssignment(assignment)" class="mt-1">
                              <span class="badge badge-primary badge-sm">Original</span>
                            </div>
                            <div
                              v-else-if="isCascadedAssignment(assignment)"
                              class="mt-1"
                            >
                              <span class="badge badge-warning badge-sm">
                                <vue-feather
                                  type="arrow-right"
                                  size="10"
                                  class="me-1"
                                ></vue-feather>
                                Cascaded
                              </span>
                              <span
                                v-if="assignment.cascadeInfo?.cascadeGeneration"
                                class="badge badge-info badge-sm ms-1"
                              >
                                Gen {{ assignment.cascadeInfo.cascadeGeneration }}
                              </span>
                            </div>
                          </td>
                          <td>
                            <div>
                              <strong>{{ assignment.employeeId.employeeName }}</strong
                              ><br />
                              <small>{{ assignment.employeeId.employeeCode }}</small>
                            </div>
                            <div v-if="assignment.assignedBy" class="mt-1">
                              <small class="text-muted">
                                Assigned by: {{ assignment.assignedBy.employeeName }}
                              </small>
                            </div>
                          </td>
                          <td>
                            <div>
                              <span
                                v-if="assignment.isCompletedWork"
                                class="badge badge-success badge-sm"
                                >Completed</span
                              >
                              <span
                                v-else-if="assignment.workStarted"
                                class="badge badge-info badge-sm"
                                >Started</span
                              >
                              <span v-else class="badge badge-warning badge-sm"
                                >Pending</span
                              >
                            </div>
                            <div class="mt-1">
                              <span
                                v-if="assignment.isVerified"
                                class="badge badge-primary badge-sm"
                                >Verified</span
                              >
                              <span
                                v-if="assignment.requiresRework"
                                class="badge badge-danger badge-sm"
                                >Needs Rework</span
                              >
                            </div>
                            <div
                              v-if="
                                assignment.priority && assignment.priority !== 'medium'
                              "
                              class="mt-1"
                            >
                              <span
                                class="badge"
                                :class="getPriorityBadgeClass(assignment.priority)"
                              >
                                {{ assignment.priority.toUpperCase() }}
                              </span>
                            </div>
                          </td>
                          <td>
                            {{ assignment.assignmentDetails.workDescription || "N/A" }}
                          </td>
                          <td>
                            <span
                              v-if="assignment.workStatus.qualityScore"
                              class="badge badge-info"
                            >
                              {{ assignment.workStatus.qualityScore }}/10
                            </span>
                            <span v-else>N/A</span>
                          </td>
                          <td>
                            <span
                              v-if="assignment.photos && assignment.photos.length > 0"
                              class="badge badge-secondary"
                            >
                              {{ assignment.photos.length }} photos
                            </span>
                            <span v-else>No photos</span>
                          </td>
                          <td>
                            <small>
                              <div>
                                <strong>Assigned:</strong>
                                {{ assignment.formattedDates.assignedDate }}
                              </div>
                              <div v-if="assignment.formattedDates.workStartedAt">
                                <strong>Started:</strong>
                                {{ assignment.formattedDates.workStartedAt }}
                              </div>
                              <div v-if="assignment.formattedDates.workCompletedAt">
                                <strong>Completed:</strong>
                                {{ assignment.formattedDates.workCompletedAt }}
                              </div>
                              <div v-if="assignment.formattedDates.verifiedAt">
                                <strong>Verified:</strong>
                                {{ assignment.formattedDates.verifiedAt }}
                              </div>
                            </small>
                          </td>
                          <td>
                            <div v-if="assignment.cascadeInfo" class="text-center">
                              <small class="text-muted">
                                Gen {{ assignment.cascadeInfo.cascadeGeneration || 1 }}
                              </small>
                              <div
                                v-if="assignment.cascadeInfo.totalOriginalAssignees > 1"
                              >
                                <small class="text-info">
                                  {{ assignment.cascadeInfo.remainingAssignees }}/{{
                                    assignment.cascadeInfo.totalOriginalAssignees
                                  }}
                                  remaining
                                </small>
                              </div>
                            </div>
                            <div v-else class="text-center">
                              <small class="text-muted">Original</small>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-else class="text-muted text-center py-3">
                    No assignments found
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- KYT Data -->
    <div
      class="row"
      v-if="
        kytDetail.kytData &&
        kytDetail.kytData.manpower &&
        kytDetail.kytData.manpower.length > 0
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5>KYT Data - Manpower</h5>
          </div>
          <div class="card-body">
            <div
              v-for="manpowerData in kytDetail.kytData.manpower"
              :key="manpowerData._id"
              class="mb-3"
            >
              <h6>{{ manpowerData.category }} - {{ manpowerData.logNo }}</h6>
              <div class="table-responsive">
                <table class="table table-sm">
                  <thead>
                    <tr>
                      <th>Sub Category</th>
                      <th>Date</th>
                      <th>Problem</th>
                      <th>Solution</th>
                      <th>Status</th>
                      <th>Completion</th>
                      <th>Assignments</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="(subCatData, index) in manpowerData.subCategories"
                      :key="index"
                    >
                      <td>{{ subCatData.subCategory }}</td>
                      <td>{{ subCatData.subCategoryDate }}</td>
                      <td>{{ subCatData.problem }}</td>
                      <td>{{ subCatData.solution }}</td>
                      <td>
                        <span
                          class="badge"
                          :class="getSubCategoryStatusBadgeClass(subCatData.status)"
                        >
                          {{ subCatData.status }}
                        </span>
                      </td>
                      <td>{{ subCatData.completionPercentage }}%</td>
                      <td>
                        {{ subCatData.completedAssignments }}/{{
                          subCatData.totalAssignments
                        }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Dates Information -->
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h5>Important Dates</h5>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-md-3">
                <h6>Created At</h6>
                <p>{{ kytDetail.formattedDates?.createdAt }}</p>
              </div>
              <div class="col-md-3">
                <h6>Updated At</h6>
                <p>{{ kytDetail.formattedDates?.updatedAt }}</p>
              </div>
              <div class="col-md-3">
                <h6>NFD</h6>
                <p>{{ kytDetail.formattedDates?.NFD }}</p>
              </div>
              <div class="col-md-3">
                <h6>Closed At</h6>
                <p>{{ kytDetail.formattedDates?.closedAt || "Not closed" }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid" v-else-if="!loading">
    <div class="text-center p-5">
      <vue-feather type="alert-circle" size="48" class="text-danger mb-3"></vue-feather>
      <h5>KYT not found</h5>
      <p class="text-muted">The requested KYT could not be found.</p>
      <button @click="goBack" class="btn btn-primary">
        <vue-feather type="arrow-left" class="me-1"></vue-feather>
        Go Back
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { useRouter, useRoute } from "vue-router";
import { useToast } from "vue-toast-notification";
import { kytChainService } from "@/services/kytChainService";
import type { KytDetail } from "@/types/kyt-chain";

const router = useRouter();
const route = useRoute();
const toast = useToast();

// Get parameters from route
const logNo = ref<string>(route.params.logNo as string);
const kytId = ref<string>(route.params.kytId as string);

// Reactive data
const loading = ref(false);
const kytDetail = ref<KytDetail | null>(null);

// Methods
const fetchKytDetail = async () => {
  loading.value = true;
  try {
    const response = await kytChainService.getKytDetail(logNo.value, kytId.value);
    if (response.success) {
      kytDetail.value = response.data.kyt;
    } else {
      toast.error(response.message || "Failed to fetch KYT details");
    }
  } catch (error) {
    console.error("Error fetching KYT details:", error);
    toast.error("Error fetching KYT details");
  } finally {
    loading.value = false;
  }
};

const refreshData = () => {
  fetchKytDetail();
};

const goBack = () => {
  router.push(`/kyt-chain/logs/${logNo.value}/kyts`);
};

const exportData = async () => {
  try {
    const blob = await kytChainService.exportLogData(logNo.value);
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `kyt-detail-${logNo.value}-${kytId.value}.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
    document.body.removeChild(a);
    toast.success("Data exported successfully");
  } catch (error) {
    console.error("Export error:", error);
    toast.error("Failed to export data");
  }
};

const getKytStatusBadgeClass = (status: string) => {
  switch (status.toLowerCase()) {
    case "pending":
      return "badge-warning";
    case "approved":
      return "badge-success";
    case "completed":
      return "badge-primary";
    case "closed":
      return "badge-secondary";
    default:
      return "badge-secondary";
  }
};

const getSubCategoryStatusBadgeClass = (status: string) => {
  switch (status.toLowerCase()) {
    case "pending":
      return "badge-warning";
    case "in-progress":
      return "badge-info";
    case "completed":
      return "badge-success";
    case "closed":
      return "badge-secondary";
    default:
      return "badge-secondary";
  }
};

const getProgressBarClass = (percentage: number) => {
  if (percentage < 30) return "bg-danger";
  if (percentage < 70) return "bg-warning";
  return "bg-success";
};

const parseContactPerson = (contactPersonStr: string) => {
  try {
    // The contact_person is a string representation of an object
    // We need to parse it safely
    if (!contactPersonStr) return null;

    // Try to extract the values using regex since it's not valid JSON
    const nameMatch = contactPersonStr.match(/name:\s*'([^']*)'/);
    const designationMatch = contactPersonStr.match(/designation:\s*'([^']*)'/);
    const phoneMatch = contactPersonStr.match(/phone:\s*'([^']*)'/);
    const altPhoneMatch = contactPersonStr.match(/altPhone:\s*'([^']*)'/);
    const emailMatch = contactPersonStr.match(/email:\s*'([^']*)'/);

    return {
      name: nameMatch ? nameMatch[1] : "",
      designation: designationMatch ? designationMatch[1] : "",
      phone: phoneMatch ? phoneMatch[1] : "",
      altPhone: altPhoneMatch ? altPhoneMatch[1] : "",
      email: emailMatch ? emailMatch[1] : "",
    };
  } catch (error) {
    console.error("Error parsing contact person:", error);
    return null;
  }
};

// Chain-related helper methods
const getKytGeneration = () => {
  // Since we don't have cascade info in the current response, we'll assume this is generation 1
  // In a real implementation, this would come from the API response
  return 1;
};

const getKytPosition = () => {
  return "Current KYT in chain";
};

const getChainGeneration = () => {
  return getKytGeneration();
};

const getChainStatus = () => {
  if (!kytDetail.value) return "Unknown";

  if (kytDetail.value.isCompleted) return "Chain Complete";
  if (hasIncompleteWork()) return "Chain Active";
  return "Chain In Progress";
};

const getChainStatusBadge = () => {
  const status = getChainStatus();
  switch (status) {
    case "Chain Complete":
      return "badge-success";
    case "Chain Active":
      return "badge-warning";
    default:
      return "badge-info";
  }
};

const getOriginalWorkCompleted = () => {
  if (!kytDetail.value?.comprehensiveStats) return 0;
  return kytDetail.value.comprehensiveStats.overallCompletion;
};

const getCascadedAssignments = () => {
  if (!kytDetail.value?.subCategories) return 0;

  return kytDetail.value.subCategories.reduce((total, subCat) => {
    return (
      total +
      (subCat.assignments?.filter((a) => a.cascadeInfo?.cascadeGeneration > 1).length ||
        0)
    );
  }, 0);
};

const getIncompleteAssignments = () => {
  if (!kytDetail.value?.comprehensiveStats) return 0;
  return kytDetail.value.comprehensiveStats.pendingAssignments;
};

const getChainProgressBarClass = (percentage: number) => {
  if (percentage >= 90) return "bg-success";
  if (percentage >= 70) return "bg-info";
  if (percentage >= 50) return "bg-warning";
  return "bg-danger";
};

const hasIncompleteWork = () => {
  if (!kytDetail.value?.subCategories) return false;

  return kytDetail.value.subCategories.some((subCat) =>
    subCat.assignments?.some((assignment) => !assignment.isCompletedWork)
  );
};

const isCascadedSubCategory = (subCategory: any) => {
  return subCategory.cascadeInfo?.cascadeGeneration > 1;
};

const isOriginalAssignment = (assignment: any) => {
  return !assignment.cascadeInfo || assignment.cascadeInfo.cascadeGeneration <= 1;
};

const isCascadedAssignment = (assignment: any) => {
  return assignment.cascadeInfo?.cascadeGeneration > 1;
};

const getPriorityBadgeClass = (priority: string) => {
  switch (priority.toLowerCase()) {
    case "high":
      return "badge-danger";
    case "medium":
      return "badge-warning";
    case "low":
      return "badge-secondary";
    default:
      return "badge-secondary";
  }
};

const formatDate = (dateString: string) => {
  if (!dateString) return "N/A";
  try {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB");
  } catch (error) {
    return dateString;
  }
};

const viewChainOverview = () => {
  router.push(`/kyt-chain/logs/${logNo.value}/kyts`);
};

const createNextKyt = () => {
  // This would trigger the creation of a new KYT with incomplete work
  // Implementation would depend on your API
  console.log("Creating next KYT for incomplete work...");
  toast.info("Feature coming soon: Create next KYT with incomplete work");
};

// Lifecycle
onMounted(() => {
  fetchKytDetail();
});
</script>

<style scoped>
.stat-card {
  padding: 20px;
  border-radius: 10px;
  color: white;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
}

.stat-icon {
  margin-right: 15px;
  opacity: 0.8;
}

.stat-content h4 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
}

.stat-content span {
  font-size: 0.875rem;
  opacity: 0.9;
}

.progress {
  border-radius: 10px;
  height: 20px;
}

.progress-bar {
  border-radius: 10px;
  transition: width 0.3s ease;
}

.card {
  box-shadow: 0 0 20px rgba(89, 102, 122, 0.1);
  border: 1px solid #e4e7ed;
  margin-bottom: 20px;
}

.table th {
  background-color: #f8f9fa;
  border-top: none;
  font-weight: 600;
  color: #495057;
}

.badge {
  font-size: 0.75rem;
  padding: 0.375rem 0.75rem;
}

.badge-sm {
  font-size: 0.65rem;
  padding: 0.25rem 0.5rem;
}

.table-borderless td {
  border: none;
  padding: 0.5rem 0;
}

.table-borderless td:first-child {
  width: 30%;
  color: #6c757d;
}

.card.border {
  border-color: #dee2e6 !important;
}

.bg-light {
  background-color: #f8f9fa !important;
}

/* Chain-specific styles */
.chain-breadcrumb {
  display: flex;
  align-items: center;
  font-size: 0.95rem;
}

.chain-stat {
  padding: 15px;
  border-radius: 10px;
  color: white;
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  position: relative;
  overflow: hidden;
}

.chain-stat .stat-icon {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 15px;
  background: rgba(255, 255, 255, 0.2);
}

.chain-stat .stat-content h4 {
  font-size: 1.8rem;
  font-weight: 700;
  margin: 0;
  line-height: 1;
}

.chain-stat .stat-content span {
  font-size: 0.85rem;
  opacity: 0.9;
  font-weight: 500;
}

.chain-stat .stat-content small {
  font-size: 0.75rem;
  opacity: 0.8;
}

.chain-actions {
  display: flex;
  align-items: center;
}

/* Enhanced cascade indicators */
.badge-warning.badge-sm {
  background-color: #ffc107;
  color: #212529;
}

.badge-info.badge-sm {
  background-color: #17a2b8;
  color: white;
}

/* Progress bar enhancements */
.progress {
  background-color: #e9ecef;
  border-radius: 8px;
}

.progress-bar {
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.875rem;
}

/* Card enhancements */
.card.border-primary {
  border-width: 2px;
}

.card-header.bg-primary {
  border-bottom: 2px solid #0056b3;
}

/* Table enhancements */
.table th {
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.badge-sm {
  font-size: 0.65rem;
  padding: 0.2rem 0.4rem;
  border-radius: 0.25rem;
}

/* Responsive improvements */
@media (max-width: 768px) {
  .chain-breadcrumb {
    flex-direction: column;
    align-items: flex-start;
  }

  .chain-actions {
    margin-top: 10px;
  }

  .chain-stat {
    margin-bottom: 10px;
  }

  .chain-stat .stat-content h4 {
    font-size: 1.5rem;
  }
}
</style>
